import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import axios from "axios";
import { pre, updateRedirectURL } from "../api/api";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../Components/Loader";
import { useSelector } from 'react-redux'
import Lottie from 'lottie-react';
import front from '../Animation/front.json'
import Cookies from 'js-cookie';
import { subscribe_api } from '../api/api';
import { v4 as uuidv4 } from 'uuid';



const LoginRoute = () => {
  const navigate = useNavigate();
  const { lang } = useSelector((state) => state.langSlice)

  const [number, setNumber] = useState(null);
  const [loading, setLoading] = useState(false);
  const [ip, setIP] = useState(null);
  const [subLoading, setSubLoading] = useState(false);
  const [debugStatus, setDebugStatus] = useState("Initializing...");
  const [apiResponse, setApiResponse] = useState("");
  const [submitStatus, setSubmitStatus] = useState("Waiting...");
  const [userAgent, setUserAgent] = useState(null)


  const params = new URLSearchParams(window.location.search);
const ext_ref = params.get("ext_ref") || uuidv4();
const partner = params.get("partner") || "";


  useEffect(() => {
    const user_agent = navigator.userAgent;
    console.log("User-Agent:", user_agent);
    setUserAgent(user_agent);
  }, []);




  let token = Cookies.get('token') // => 'value'

  useEffect(() => {
    const fetchIP = async () => {
      try {
        const res = await axios.get('https://api.ipify.org?format=json');
        setIP(res.data.ip);
      } catch (err) {
        console.log('Error fetching IP:', err);
      }
    };

    fetchIP();
  }, []);

  console.log(ip)




  const getToken = async () => {
    const CLIENT_ID = '12fjeqn3lgrpb6m8rmagb2uco4';
    const CLIENT_SECRET = 'h450m9f3kou0pp3l5ig6p3teth7heauuhp2v8gfcrm3546ndq94';
    const url = `https://third-party.auth.eu-west-1.amazoncognito.com/oauth2/token`
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      "Authorization": "Basic " + btoa(`${CLIENT_ID}:${CLIENT_SECRET}`),
    };

    const body = new URLSearchParams({
      grant_type: "client_credentials",
    }).toString();

    console.log({ url: url, headers: headers, body: body })

    try {
      const tokenRes = await axios.post(url, body, { headers });
      console.log(tokenRes, tokenRes.data.access_token, 'token ------------------------')
      const oneHour = 1 / 24;
      Cookies.set('token', tokenRes?.data?.access_token, { expires: oneHour })
      return tokenRes?.data?.access_token;
    }
    catch (err) {
      throw Error;
    }

  }




  const getHeaders = async () => {
    // setLoading(true)
    try {
      setLoading(true)
      setDebugStatus("Getting Token...");
      if (!token) {
        token = await getToken();
      }
      console.log(token);
      setDebugStatus("Token Received. Calling MSISDN API...");
      const xhr = new XMLHttpRequest();
      const url = 'https://identity.safaricom.com/partner/api/v2/fetchMaskedMsisdn';

      xhr.open('GET', url, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Authorization', `Bearer ${token}`);
      xhr.setRequestHeader('X-App', 'he-partner');
      xhr.setRequestHeader('X-Source-System', 'he-partner');
      xhr.setRequestHeader('X-MessageID', '1234');

      console.log(xhr, 'xhr--------')
      xhr.onreadystatechange = function () {

        if (xhr.readyState === 4) {

          setLoading(false);

          setApiResponse(xhr.responseText);

          if (xhr.status === 200) {

            try {

              const response = JSON.parse(xhr.responseText);

              const msisdn =
                response?.ServiceResponse?.ResponseBody?.Response?.Msisdn ?? null;

              if (msisdn) {

                setDebugStatus(`✅ MSISDN FOUND: ${msisdn}`);

                setNumber(msisdn);

              } else {

                setDebugStatus("❌ API Success But MSISDN Missing");

              }

            } catch (error) {

              setDebugStatus("❌ Response Parse Error");

            }

          } else {

            setDebugStatus(`❌ API Failed. Status: ${xhr.status}`);

          }

        }

      };


      xhr.send();

      // console.log(res)


    }
    catch (err) {
      console.log(err);
      // setLoading(false)
    }
    // setLoading(false)
  }


  console.log(number, 'number----------------------------')

  useEffect(() => {
    getHeaders()
  }, [])

const submitHandler = (e) => {
  e.preventDefault();

  setSubLoading(true);

  try {
    // Build redirect URL with ext_ref (and partner if available)
    const queryParams = new URLSearchParams();

    queryParams.append("ext_ref", ext_ref);

    if (partner) {
      queryParams.append("partner", partner);
    }

    // const redirectUrl = `https://dsdpstg-cg.safaricom.com/consent-gateway/300002304?${queryParams.toString()}`;
    const redirectUrl = `https://dsdp-cg.safaricom.com/consent-gateway/001048837588?${queryParams.toString()}`;
                      

    console.log("Redirect URL:", redirectUrl);

    // Redirect in same tab
    window.location.href = redirectUrl;

    // If you want to open in a new tab instead, use:
    // window.open(redirectUrl, "_blank");

  } catch (err) {
    console.error(err);
    setSubLoading(false);
  }
};



  return (
    <>
      <Navbar />
      <div className="mt-12 w-full  flex justify-center items-center">
        <div className="p-10 bg-[black]  shadow-inner shadow-[#fff]  w-2/4 flex  flex-col items-center gap-4 sm:flex-row sm:gap-0   rounded-lg max-[800px]:w-3/4">
          <div className="w-[40%] h-full flex justify-center">
            <Lottie
              animationData={front}
              className="w-[90%]"
            />
          </div>
        <form
  className="sm:w-[45%] mx-auto flex flex-col justify-center"
  onSubmit={submitHandler}
>
  <img
    src="/assets/images/kid.png"
    className="text-white text-3xl text-center mb-3"
  />

  <p className="text-white text-xl text-center w-full">
    Welcome to Kids Zone Pro
  </p>

  <div className="text-xl text-center font-semibold text-[#f3e739] p-2">
    Price 15 KSH / Daily
  </div>

<button
  type="submit"
  disabled={subLoading}
  className="text-white bg-green-700 hover:bg-green-800 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center flex items-center justify-center gap-2"
>
  {subLoading ? (
    <>
      <svg
        className="animate-spin h-5 w-5"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        />
      </svg>
      Redirecting...
    </>
  ) : (
    "Subscribe"
  )}
</button>
</form>
          {/* <div>
            {loading && <Loader />}
          </div> */}
        </div>
      </div>
    </>
  );
};

export default LoginRoute;
